<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">健康チェック</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <div class="page-content__article-section-body--indent">
            <p>
              レクリエーショナルスクーバダイビングおよびフリーダイビングには、心身の健康が必要です。ダイビングをするにあたって危険を生じうる状態があり、以下にそれをあげてあります。こうした条件があてはまる人、あるいは、その傾向がある人は、医師による評価が必要です。この「ダイバーメディカル/参加者チェックシート」は、医師の評価を受ける必要があるかどうかを判断するためのものです。このチェックシートにないダイビング適性に関する懸念が少しでもあれば、ダイビングをする前に医師に相談してください。具合が悪いと感じたら、ダイビングしないでください。伝染性の病気にかかっているかもしれないと思うなら、ダイブトレーニングやダイビング活動に参加しないようにして、自分と他の人を守ってください。このチェックシートでの“ダイビング”という用語はスクーバダイビングとフリーダイビングの両方をさします。このチェックシートは基本的に新しくダイバーになろうという人に対して最初に医学的なスクリーニングを行うためのものですが、継続教育に参加するダイバーにも使えます。あなたの安全、そして、一緒にダイビングする他の人の安全のために、すべての質問に正直に答えてください。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">お願い</h4>
          <div class="page-content__article-section-body">
            <p>
              レクリエーショナルダイビングやフリーダイビングコースに参加する前にこのチェックシートに記入してください。<br />
              女性への注意:妊娠中、あるいは、妊娠予定の場合は、ダイビングをしないでください。
            </p>
          </div>
        </section>
        <section>
          <span class="input-form__label-validation-message">{{ validationMessage }}</span>
        </section>
        <section>
          <table class="table table-striped table-bordered page-content__medical-check-table">
            <tbody>
              <tr v-for="question in mainSection.questions" :key="question.question_id">
                <td class="page-content__medical-check-table-col-no">
                  <div class="page-content__medical-check-table-col-inner--center">
                    {{ question.name }}
                  </div>
                </td>
                <td class="page-content__medical-check-table-col-question">
                  <div class="page-content__medical-check-table-col-inner">
                    {{ question.question }}
                  </div>
                </td>
                <td class="page-content__medical-check-table-col-yes">
                  <div class="page-content__medical-check-table-col-inner--center">
                    <label for="q01-yes">
                      <input
                        type="radio"
                        :id="question.id"
                        :name="question.id"
                        value="はい"
                        v-model="question.answer"
                      /><span>はい</span>
                      <span v-show="question.doctor_check_required">*</span>
                    </label>
                    <span
                      v-show="
                        question.sub_section_sign !== null &&
                        question.answer === 'はい' &&
                        isShowSubQuestions
                      "
                      class="page-content__medical-check-table-col-inner--jump-message"
                      >{{ question.sub_section_sign }}欄へ</span
                    >
                  </div>
                </td>
                <td class="page-content__medical-check-table-col-not">
                  <div class="page-content__medical-check-table-col-inner--center">
                    <label for="q01-not">
                      <input
                        type="radio"
                        :id="question.id"
                        :name="question.id"
                        value="いいえ"
                        v-model="question.answer"
                      /><span>いいえ</span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section v-show="section.visible" v-for="section in subSections" :key="section.id">
          <table class="table table-striped table-bordered page-content__medical-check-table">
            <thead>
              <tr>
                <th colspan="3">{{ section.sign }}欄 - {{ section.title }}：</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="question in section.questions" :key="question.id">
                <td class="page-content__medical-check-table-col-question" colspan="2">
                  <div class="page-content__medical-check-table-col-inner">
                    {{ question.question }}
                  </div>
                </td>
                <td class="page-content__medical-check-table-col-yes">
                  <div class="page-content__medical-check-table-col-inner--center">
                    <label for="q01-yes">
                      <input
                        type="radio"
                        :id="question.id"
                        :name="question.id"
                        value="はい"
                        v-model="question.answer"
                      /><span>はい</span>
                      <span v-show="question.doctor_check_required">*</span>
                    </label>
                    <span class="page-content__medical-check-table-col-inner--jump-message">{{
                      question.subQuestionId
                    }}</span>
                  </div>
                </td>
                <td class="page-content__medical-check-table-col-not">
                  <div class="page-content__medical-check-table-col-inner--center">
                    <label for="q01-not">
                      <input
                        type="radio"
                        :id="question.id"
                        :name="question.id"
                        value="いいえ"
                        v-model="question.answer"
                      /><span>いいえ</span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <span class="input-form__label-validation-message">{{ validationMessage }}</span>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/consent" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link v-show="isSubmit" to="/confirm" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              申込内容の確認画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="overlay" v-show="isShowDialog" class="page-content__overlay">
      <div id="content" class="page-content__overlay-contents">
        <article>
          <section>
            <h4 class="page-content__article-section-title--dialog-red">
              【ご注意】お申込みの前に！
            </h4>
            <div class="page-content__article-section-body--dialog-message">
              <p>
                *質問の3、5、10のいずれかに、あるいは、A～G欄の質問のいずれかに「はい」と回答した場合、実技講習の受講前に医師の診断が必要となります。医師の診断の後、コースの受講が認められない場合は、お客様のお申込みをお断りさせて頂きます。その場合、コース受講料を返金させて頂きますので、training@bsac.jp
                までその旨お申し出ください。<br />
                また、医師の診断書の確認ができない場合、受講をお断りする場合がございますので、あらかじめご了承の程よろしくお願いいたします。<br />
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <div class="page-footer__next-button-inner">
            <button class="btn btn-secondary rounded-pill" @click="clickCancel">再確認する</button>
          </div>
          <div class="page-footer__next-button-inner">
            <router-link v-show="isSubmit" to="/confirm" custom v-slot="{ navigate }">
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
                了解して申込内容の確認画面へ進む
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  beforeRouteLeave(to, from, next) {
    //console.log('to.path:' + to.path);
    if (to.path === '/consent') next();

    if (this.isDialogShown) {
      // ドクターチェックダイアログは１度のみ表示する
      this.isNextButton = true;
    } else {
      this.isShowDialog = this.requireDoctorCheck;
      this.isNextButton = !this.requireDoctorCheck;
    }
    // 入力値検証がNGの場合は遷移できない
    next(this.isSubmit && this.isNextButton);

    // ドクターチェックダイアログは１度のみ表示する
    this.isDialogShown = true;
  },
  computed: {
    /**
     * サブ質問を表示するかを判定する
     */
    isShowSubQuestions: function () {
      return this.$store.getters['medicalCheck/isShowSubQuestions'];
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      return !this.validationMessage;
    },
    /**
     * 入力内容検証時のメッセージを取得する
     */
    validationMessage: function () {
      return this.$store.getters['medicalCheck/validationMessage'];
    },
    /**
     * メインの質問を取得する
     */
    mainSection: function () {
      return this.$store.getters['medicalCheck/mainSection'];
    },
    /**
     * ドクターチェックの必要可否を取得する
     */
    requireDoctorCheck: function () {
      return this.$store.getters['medicalCheck/requireDoctorCheck'];
    },
    /**
     * サブの質問を取得する
     */
    subSections: function () {
      return this.$store.getters['medicalCheck/subSectionsForDisplay'];
    },
  },
  created() {
    // テスト用
    if (process.env.RAILS_ENV === 'development') {
      this.mainSection.questions.forEach((question) => {
        question.answer = 'いいえ';
      });
    }
  },
  data() {
    return {
      isDialogShown: false,
      isNextButton: false,
      isShowDialog: false,
      medicalCheck: null,
    };
  },
  methods: {
    /**
     * 再確認するボタンをクリックする
     */
    clickCancel: function () {
      this.isDialogShown = false;
      this.isNextButton = false;
      this.isShowDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';

/* メディカルチェックテーブル */
.page-content__medical-check-table {
  width: 100%;

  font-size: 0.8rem;

  &-col-no {
    width: 30px;
  }
  // &-col-question {
  // }
  &-col-yes {
    width: 75px;
  }
  &-col-not {
    width: 75px;
  }

  &-col-inner {
    &--center {
      text-align: center;
    }
    &--jump-message {
      margin: 0.25rem 0 0 0;
      display: block;
    }
  }
}
/* メディカルチェックテーブル */
</style>
